import { createAction, props } from '@ngrx/store';
import { PageAccessLogDTO } from 'brain-data/model/access-log.model';
import { AccessLogQuery } from 'brain-data/service/access-log/access-log-admin.service';

export const loadAdminAccessLogs = createAction('[Access logs] load admin access logs', props<{ query: AccessLogQuery }>());

export const loadAdminAccessLogsSuccess = createAction('[Access logs] load admin access logs success', props<{ page: PageAccessLogDTO }>());

export const loadAdminAccessLogsError = createAction('[Access logs] load admin access logs error', props<{ error: any }>());
